import React from 'react';
import { Paper, Typography, Link, Grid } from '@mui/material';
import { useTheme } from '@mui/system';



const Footer = () => {
    const theme = useTheme();
    const linkStyles = {
        textDecoration: 'none',
    };

    const mainContainerStyles = {
        width: '50%',
        padding: '20px',
        margin: 'auto',
        padding: '5px',
        [theme.breakpoints.down('lg')]: {
            width: '100%',
        }

    }
    const listContainerStyles = {
        textAlign: 'center'
    }
    const linksDomain = 'https://about.hyperdart.com/'
    return (
        <Paper padding={0} elevation={0}>
            <Grid container justifyContent="center" spacing={2} sx={mainContainerStyles} >
                <Grid item xs={6} sm={3} sx={listContainerStyles}>
                    <Typography variant="body2">
                        <Link href={`${linksDomain}/privacy-policy`} color="inherit" sx={linkStyles} target="_blank">
                            Privacy Policy
                        </Link>
                    </Typography>
                </Grid>
                <Grid item xs={6} sm={3} sx={listContainerStyles}>
                    <Typography variant="body2">
                        <Link href={`${linksDomain}/terms-and-conditions`} color="inherit" sx={linkStyles} target="_blank">
                            Terms and Conditions
                        </Link>
                    </Typography>
                </Grid>
                <Grid item xs={6} sm={3} sx={listContainerStyles}>
                    <Typography variant="body2">
                        <Link href={`${linksDomain}/contact`} color="inherit" sx={linkStyles} target="_blank">
                            Support/Contact Us
                        </Link>
                    </Typography>
                </Grid>
                <Grid item xs={6} sm={3} sx={listContainerStyles}>
                    <Typography variant="body2">
                        <Link href={`${linksDomain}/about`} color="inherit" sx={linkStyles} target="_blank">
                            About Us
                        </Link>
                    </Typography>
                </Grid>
            </Grid>
        </Paper>
    );
};

export default Footer;
